import { render, staticRenderFns } from "./truth_pc_cn.vue?vue&type=template&id=5ef69038&scoped=true&"
import script from "./truth_pc_cn.vue?vue&type=script&lang=js&"
export * from "./truth_pc_cn.vue?vue&type=script&lang=js&"
import style0 from "./truth_pc_cn.vue?vue&type=style&index=0&id=5ef69038&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef69038",
  null
  
)

export default component.exports